import { PathEnum } from "core/routes/path.enum";
import { Navigate, Route, Routes } from "react-router-dom";
import ActivitiesPage from "./activities";
import ActivityDetailsPage from "./activities/activity-details";
import GuidaPage from "./guida";
import ImageLibraryPage from "./image-library";
import SignPage from "./signs";
import UserManagerPage from "./user-manager";

const PrivateRouter: React.FC = () => {
	return (
		<Routes>
			<Route path="*" element={<Navigate to={PathEnum.ACTIVITIES} />} />

			<Route path={PathEnum.ACTIVITIES} element={<ActivitiesPage />} />
			<Route
				path={`${PathEnum.ACTIVITIES}/:entId`}
				element={<ActivityDetailsPage />}
			/>

			<Route path={PathEnum.LIBRARY} element={<ActivitiesPage isLibrary />} />
			<Route
				path={`${PathEnum.LIBRARY}/:entId`}
				element={<ActivityDetailsPage isLibrary />}
			/>

			<Route
				path={`${PathEnum.IMAGE_LIBRARY}`}
				element={<ImageLibraryPage />}
			/>

			<Route path={`${PathEnum.SIGN}`} element={<SignPage />} />

			<Route path={PathEnum.GUIDA} element={<GuidaPage />} />

			<Route path={PathEnum.USER_MANAGER} element={<UserManagerPage />} />
		</Routes>
	);
};
export default PrivateRouter;
